<app-home-title-list-button
        [titleTranslocoKey]="'home.shared.faq.title'"
        [items]="items"
        [btnRouterLink]="'/home/faq'"
        [btnLabelTranslocoKey]="'home.shared.faq.go_to_faq_page_button'">
</app-home-title-list-button>